export default __webpack_public_path__ + "static/crm_software-ade9833075f7d3bb1049197254b3eb23.webp";